export const courses = [
  {
    id: 'toeic',
    imgClass: 'toeic',
    emoji: '🎯',
    tag: 'TOEIC – English',
    tagClass: 'toeic',
    title: 'TOEIC 400 → 900+',
    desc: 'Lộ trình dành cho những bạn muốn vừa cải thiện điểm số TOEIC, vừa xây dựng khả năng sử dụng tiếng Anh trong công việc và cuộc sống hằng ngày.',
    features: [
      'Hệ thống lại từ vựng & ngữ pháp theo chủ điểm sách Mai Lan Hương',
      'Luyện đề TOEIC chuẩn ETS',
      'Theo dõi tiến độ học tập qua các bài đánh giá định kỳ',
      'Xây dựng phản xạ nghe — hiểu — giao tiếp tự nhiên trong suốt quá trình học',
    ],
    page: 'toeic',
  },
  {
    id: 'jlpt',
    imgClass: 'jlpt',
    emoji: '🌸',
    tag: 'JLPT – 日本語',
    tagClass: 'jlpt',
    title: 'Tiếng Nhật N5 → N3',
    desc: 'Lộ trình giúp bạn xây nền tiếng Nhật vững vàng, đồng thời dần quen với việc giao tiếp và tiếp nhận ngôn ngữ trong môi trường thực tế.',
    features: [
      'Nắm vững Hiragana, Katakana & ngữ pháp nền tảng',
      'Rèn phản xạ hội thoại và tương tác cùng giáo viên mỗi buổi học',
      'Luyện đọc hiểu và tăng vốn từ theo từng cấp độ JLPT',
      'Làm quen với cách dùng tiếng Nhật tự nhiên trong đời sống hằng ngày',
    ],
    page: 'jlpt',
  },
];
